import React, { useState } from 'react';
import kitchenPhoto1 from '../img/kitchen/k1.jpg';
import kitchenPhoto2 from '../img/kitchen/k2.jpg';
import kitchenPhoto3 from '../img/kitchen/k3.jpg';
import kitchenPhoto4 from '../img/kitchen/k4.jpg';
import kitchenPhoto5 from '../img/kitchen/k5.jpg';
import kitchenPhoto6 from '../img/kitchen/k6.jpg';
import kitchenPhoto7 from '../img/kitchen/k7.jpg';
import kitchenPhoto8 from '../img/kitchen/k8.jpg';
import kitchenPhoto9 from '../img/kitchen/k9.jpg';

export const KitchenPortfolio = () => {

    const photos = [kitchenPhoto1,kitchenPhoto2,kitchenPhoto3,kitchenPhoto4,kitchenPhoto5,kitchenPhoto6,kitchenPhoto7,kitchenPhoto8,kitchenPhoto9];
    const [imgActive, setImgActive] = useState(kitchenPhoto1);  
    const [selectedIndex, setSelectedIndex] = useState(0);
    const changeImg = (img, index) => {        
        setImgActive(img);
        setSelectedIndex(index);
    }

    return (
        <div className = "row d-flex justify-content-center align-items-center">
            <div className = "col-6">                
                {                        
                        [0,1,2].map((e, index) => {
                            return (
                                <div className = "row justify-content-center" key={index}> 
                                {
                                    photos.slice(3*e,3*e+3).map((d, index2) => {                      
                                        return (
                                            <div key = {(index2+(3*e))} className = "portfolio-img" onClick={()=> changeImg(d, (index2+(3*e)))}>                            
                                                <img src = {d} alt = "" className = "portfolio-img-prev"/>
                                                <div className = {selectedIndex ===  (index2+(3*e)) ? 'portfolio-img-prev-background-active' : 'portfolio-img-prev-background'}></div>
                                            </div>
                                        );
                                    })
                                }
                                </div>
                            );
                        })                        
                    }
            </div>
            <div className = "col-6 p-0">
                <img src={imgActive} className = "gallery-img" alt = "gallery"/>
            </div>
        </div> 
    );
}

export const KitchenPortfolioPhone = () => {

    const photos = [kitchenPhoto1,kitchenPhoto2,kitchenPhoto3,kitchenPhoto4,kitchenPhoto5,kitchenPhoto6,kitchenPhoto7,kitchenPhoto8,kitchenPhoto9];
    const [imgActive, setImgActive] = useState(kitchenPhoto1);
    const [selectedIndex, setIndex ] = useState('01'); 

    const changeImg = (img, index) => {        
        setImgActive(img);
        setIndex((index+1).toString().padStart(2,'0'));
    }

    return (                
        <div className = "row">
            <div className = "p-0 mb-4 mt-4">
                <img src={imgActive} className = "gallery-img-phone" alt = "gallery"/>
            </div>
            <p className = "gallery-info-phone">{selectedIndex}/{photos.length.toString().padStart(2,'0')}</p>
            <div className = "mt-2 container-gallery-phone">            
                <div className = "row h-100 p-0">
                    <div className = "d-flex align-items-center">
                        {photos.map((d, index) => {
                            return (
                                <div key={index} className = "w-[5.8125rem] h-[4.8875rem]">
                                    <div className = "portfolio-img-phone" onClick={()=> changeImg(d, index)}>                            
                                        <img src = {d} alt = "" className = "portfolio-img-prev-phone"/>
                                        <div className = {selectedIndex ===  ((index+1).toString().padStart(2,'0')) ? 'portfolio-img-prev-background-active' : 'portfolio-img-prev-background'}></div>
                                    </div> 
                                </div>
                            );
                        })}                                                                                             
                    </div>                                                             
                </div>
            </div> 
        </div>                                               
    );
}

